import type { AppChain } from './chain.types'

import { ChainId } from '../../web3.types'
import { arbitrum } from './arbitrum'
import { arc } from './arc'
import { base } from './base'
import { cronos } from './cronos'
import { hyperevm } from './hyperevm'
import { katana } from './katana'
import { mainnet } from './mainnet'
import { monad } from './monad'
import { optimism } from './optimism'
import { plume } from './plume'
import { polygon } from './polygon'
import { robinhood } from './robinhood'
import { sepolia } from './sepolia'
import { stable } from './stable'
import { tempo } from './tempo'
import { unichain } from './unichain'
import { worldchain } from './worldchain'

export const chains = {
  [ChainId.Mainnet]: mainnet,
  [ChainId.Optimism]: optimism,
  [ChainId.Unichain]: unichain,
  [ChainId.Polygon]: polygon,
  [ChainId.Worldchain]: worldchain,
  [ChainId.Base]: base,
  [ChainId.Hyperevm]: hyperevm,
  [ChainId.Arbitrum]: arbitrum,
  [ChainId.Plume]: plume,
  [ChainId.Katana]: katana,
  [ChainId.Stable]: stable,
  [ChainId.Monad]: monad,
  [ChainId.Tempo]: tempo,
  [ChainId.Cronos]: cronos,
  [ChainId.Robinhood]: robinhood,
  [ChainId.Arc]: arc,
  [ChainId.Sepolia]: sepolia
} as const satisfies {
  [chainId in ChainId]:
    | AppChain<{ v1: true; v2: false }, chainId>
    | AppChain<{ v1: true; v2: true }, chainId>
}

export type Chains = typeof chains

/** Chain with Morpho contract details. */
export type Chain = Chains[ChainId]

export type ChainsWithV2 = {
  [chainId in ChainId as Chains[chainId] extends AppChain<{ v1: true; v2: true }, chainId>
    ? chainId
    : never]: Extract<Chains[chainId], AppChain<{ v1: true; v2: true }, chainId>>
}
